import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import { deliveryMethods } from './constants'
import * as Styles from './styles'

const DeliveryMethod = ({ deliveryMethod }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      {deliveryMethods[deliveryMethod]?.icon}
      <Text type="bodyMRegular">{t(deliveryMethods[deliveryMethod]?.label)}</Text>
    </Styles.Container>
  )
}

export default DeliveryMethod
